import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/**
 * wsUrl:
 *  - "campaign", "<campaign_id>"
 *  - "dm", "<my_char_id>/<other_char_id>"   (room path literal)
 */
export function wsUrl(roomType, roomPath) {
  const token = localStorage.getItem("sb_token");
  const base = BACKEND_URL.replace(/^http/, "ws");
  return `${base}/api/ws/${roomType}/${roomPath}?token=${token}`;
}

export function fileUrl(path) {
  if (!path) return null;
  const token = localStorage.getItem("sb_token");
  return `${API}/files/${path}?auth=${token}`;
}
